import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SmartTable from 'views/common/table/SmartTable';
import { Input, Select } from 'antd';
import {
  checkHasAnyRoleOrPermission,
  PERMISSION,
  ROLE,
} from 'constants/permission';
import usePage from 'hooks/usePage';
import { LIST_TYPE } from 'constants/constants';
import Page from 'views/common/Page';
import { useSelector } from 'react-redux';

const config = {
  mainKey: 'code',
  name: 'manage-authorization',
  headerHeight: 50,
  rowHeight: 60,
  tableStyle: {
    minWidth: 700
  },
  columns: [
    {
      columnKey: 'No',
      title: 'No.',
      className: 'cell-y-center',
      render: (v, rowData) => {
        const { index } = rowData;
        return <span style={{ fontWeight: 400, paddingLeft: 5 }}>{index}</span>;
      },
      width: '2rem',
    },
    {
      columnKey: 'code',
      title: 'Code',
      width: '40%',
      className: 'cell-code-auth cell-y-center',
      
      render: (v, rowData) => {
        return (
          <Link className="cell-link-to" to={`/authorization/${rowData.id}`}>
            {v}
          </Link>
        );
      },
    },
    {
      columnKey: 'description',
      title: 'Description',
      className: 'cell-y-center',
      width: '30%',
    },
    {
      columnKey: 'type',
      title: 'Type',
      width: '20%',
      className: 'cell-y-center',
      
    },
  ],
};

const ManagerAuthorization = () => {
  const {
    status,
    data,
    meta,
    search,
    onChangeFieldText,
    onChangeField,
    onChangePage,
    currentPage,
  } = usePage({
    name: LIST_TYPE.AUTHORIZATION,
    pageSize: 10,
  });
  const navigate = useNavigate();
  const { permissions, roles } = useSelector((state) => state.auth);

  return (
    <Page
      title="Authorization"
      status={status}
      data={data}
      currentPage={currentPage}
      onCreate={
        checkHasAnyRoleOrPermission(
          permissions,
          roles,
          [ROLE.SYSTEM_ADMIN],
          [PERMISSION.CREATE_AUTHORIZATION]
        )
          ? () => navigate('/authorization/create')
          : null
      }
      pageSize={10}
      onChangePage={onChangePage}
      meta={meta}
      renderSearch={() => (
        <div className="page-search">
          <Input
            value={search.query}
            className="page-search__input"
            onChange={(e) => onChangeFieldText(e, 'query')}
            placeholder="Search for Code, Description"
            size="large"
          />

          <Select
            allowClear
            placeholder="Type"
            onChange={(v) => onChangeField(v, 'type')}
            value={search.type}
            className="page-search__select"
            size="large"
          >
            <Select.Option value="ROLE">Role</Select.Option>
            <Select.Option value="PERMISSION">Permission</Select.Option>
          </Select>
        </div>
      )}
      renderList={() => (
        <div className="table-item-wraper">
          <SmartTable
            config={config}
            navigate={navigate}
            dataSource={data || []}
          />
        </div>
      )}
    />
  );
};

export default ManagerAuthorization;
